import { handleActions } from 'redux-actions';
import { combineReducers } from 'redux';
import { getActionsData, getActionsDataSuccess, getActionsDataFailure, getActionsDataIdle } from '../actions';

const status_get_actionsData = handleActions(
  {
    [getActionsData.toString()]: (state, action) => 'LOADING',
    [getActionsDataSuccess.toString()]: (state, action) => 'SUCCESS',
    [getActionsDataFailure.toString()]: (state, action) => 'FAILURE',
    [getActionsDataIdle.toString()]: (state, action) => 'IDLE',
  },
  'IDLE'
);

const data_get_actionsData = handleActions(
  {
    [getActionsData.toString()]: (state: any, action) => {
      return {
        ...state
      }
    },
    [getActionsDataSuccess.toString()]: (state: any, action) => {
      return action.payload.groupRequirementIDs
        // [action.payload.groupRequirementID]: {
        //   ...action.payload
        // }
      // }
    },
    
  },
  null
);

export { status_get_actionsData, data_get_actionsData };
